import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface PropTypes extends ComponentProps<"select"> {
  label?: string;
  options: { label: string; value: string }[];
  error?: string | any;
  isInvalid?: boolean;
  containerClassName?: string;
  labelClassName?: string;
  renderOption?: (option: any) => React.ReactNode;
}

const Select = ({
  label,
  isInvalid = false,
  placeholder,
  options,
  error,
  containerClassName,
  className,
  renderOption,
  labelClassName,
  ...rest
}: PropTypes) => {
  return (
    <div className={twMerge("flex flex-col", containerClassName)}>
      {label && (
        <label className={twMerge("label text-[1rem] lg:text-xs", labelClassName)}>
          {label}
        </label>
      )}
      <select
        {...rest}
        defaultValue=""
        className={twMerge(
          "select select-bordered select-primary focus:border-none text-[1rem] lg:text-xs h-10 min-h-0 text-black text-ellipsis overflow-hidden whitespace-nowrap",
          !rest.value ? "text-gray-400" : "text-black",
          "[&_option:not(:first-child)]:text-black",
          className
        )}
        style={{
          textOverflow: 'ellipsis',
          ...rest.style,
        }}
      >
        <option disabled hidden value="" className="text-[1rem] lg:text-xs">
          {placeholder}
        </option>
        {options.map((option, index) =>
          renderOption ? (
            renderOption(option)
          ) : (
            <option
              className="text-[1rem] lg:text-xs"
              key={option.value + index}
              value={option.value}
            >
              {option.label}
            </option>
          )
        )}
      </select>

      {isInvalid && (
        <div className="label">
          <span className="label-text-alt text-red-600">{error}</span>
        </div>
      )}
    </div>
  );
};

export default Select;
